export default __webpack_public_path__ + "static/media/icon_zone_control_2.18f63542.png";